export const k = {
    projectName: 'Proceso de selección para personal Censal',
    projectCurrentVersion: '1.0.0',
    authorizationK: 'Authorization',
    hmacSignature: 'Signature',
    cRole: 'Role',
    adm_token: '_1',
    token: 'web_token' , 
    partial_token: 'mfa_token',
    permissions: '_2',
    userInformation: '_3',
    user_id: '_4',
    user_role_id: '_5',
    currentIp: '_6',
    suggestions: '_suggestions.',
    user_name: '_7',
    tipoGrupo: '_8',
    correo: '_9'
}
